import { TranslateService } from '@ngx-translate/core';
import { CompositeModel } from '../complex/composite.model';
import { TextModel } from '../primitive/text.model';
import { RadioModel } from '../complex/radio.model';
import { ConfigConstants } from '../../config/config-constants';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { DisplayDecorator } from '../../decorators/display-decorator';
import { RadioModelOptions } from '../options/radio-model-options';

const odataFollowUpVisitFlag = 'FollowUpVisitFlag';

export class ConfirmationTrainingEventCompletedModel extends CompositeModel {
    public trainingEventCompletedOptions: RadioModel<TextModel>;
    public constructor() {
        super('ConfirmationTrainingEventCompletedModel');

        const injector = CustomInjector.getInjector();
        const translate = injector.get(TranslateService);

        const optionGroup: Array<DisplayDecorator<TextModel>> = [];
        optionGroup.push(
            new DisplayDecorator(
                <string>translate.instant('CONFIRMATION_TRAINING_EVENT_OPTION_YES'),
                new TextModel(ConfigConstants.optionYes, ConfigConstants.optionValueYes),
            ),
        );
        optionGroup.push(
            new DisplayDecorator(
                <string>translate.instant('CONFIRMATION_TRAINING_EVENT_OPTION_NO'),
                new TextModel(ConfigConstants.optionNo, ConfigConstants.optionValueNo),
            ),
        );
        optionGroup.push(
            new DisplayDecorator(
                <string>translate.instant('CONFIRMATION_TRAINING_EVENT_OPTION_NA'),
                new TextModel(ConfigConstants.optionNA, ConfigConstants.optionValueNA),
            ),
        );

        this.trainingEventCompletedOptions = <RadioModel<TextModel>>(
            this.set(
                new RadioModel<TextModel>(
                    odataFollowUpVisitFlag,
                    optionGroup,
                    new RadioModelOptions({ initialSelection: 2, invalidSelection: 2 }),
                ),
            )
        );
    }

    public toJSON(): unknown {
        return {
            trainingEventSelection: this.trainingEventCompletedOptions.selectedEntry.model.value,
        };
    }
}

export class ConfirmationTrainingEventCompletedModelFromJson extends ConfirmationTrainingEventCompletedModel {
    public constructor(data: JsonConfirmationTrainingEventCompletedModel) {
        super();
        this.trainingEventCompletedOptions.selectByPredicate((entry) => entry.value === data.trainingEventSelection);
    }
}

export interface JsonConfirmationTrainingEventCompletedModel {
    trainingEventSelection: string;
}

export interface ODataConfirmationTrainingEventCompletedOutModel extends ODataObject {
    FollowUpVisitFlag: string;
}
